import React from "react";
import SuccessIcon from "../../Icon-SVG/SuccessIcon";
import "./styles.scss";

const Success = ({
  okDisable = false,
  onClickOk,
  text,
  article = "Success",
  textOK = "OK",
  icon,
  show,
  setShow,
}) => {
  return (
    <div className={`${show && "warning-backdrop"}`} onClick={() => setShow(false)}>
      <div onClick={(e) => e.stopPropagation()}>
        {show ? (
          <div className="warning">
            <div className="warning__icon">{!icon ? <SuccessIcon /> : icon}</div>
            <h3 className="article">{article}</h3>
            <p className="warning__description">{text}</p>
            <div className="flex">
              {okDisable ? null : (
                <button className="primary-button" onClick={onClickOk}>
                  {textOK}
                </button>
              )}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Success;